import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";

export const ProfilePage = ({ loggedUser, isLoading, userUpdate }) => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const navigate = useNavigate();
  const [user, setUser] = useState(loggedUser);

  const onSubmit = (data) => {
    userUpdate(data);
  };

  return (
    <>
      <div className="full-row bg-light overlay-dark py-5"
        style={{backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/banner.png)`, backgroundPosition: "center center", backgroundSize: "cover"}}>
        <div className="container">
          <div className="row text-center text-white">
            <div className="col-12">
              <h3 className="mb-2 text-white font-weight-bold">User Profile</h3>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center bg-transparent">
                  <li className="breadcrumb-item">
                    <a href="#" className="text-white">Home</a>
                  </li>
                  <li className="breadcrumb-item active text-white" aria-current="page">User Profile</li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <main>
        <div class="my-4 px-3" style={{ maxWidth: "1000px", margin: "auto" }}>
            <div class="container">
                <div class="row">
                    <div class="col-12 d-md-none mb-3">
                        <button class="btn btn-dark" data-bs-toggle="offcanvas" data-bs-target="#offcanvasSidebar" aria-controls="offcanvasSidebar">
                            <i class="bi bi-list"></i>
                        </button>
                    </div>
            
                    <div className="offcanvas offcanvas-start d-md-none" id="offcanvasSidebar" tabIndex="-1" aria-labelledby="offcanvasSidebarLabel">
                        <div class="offcanvas-header">
                            <h5 class="offcanvas-title" id="offcanvasSidebarLabel">Dashboard</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                        </div>
                        <div class="offcanvas-body">
                            <div class="box1-list">
                                <h6 style={{ cursor: "pointer" }} onClick={() => navigate("/orders")}>Orders</h6>
                                <hr />
                                <h6 style={{ cursor: "pointer" }} onClick={() => navigate("/profile")}>Edit Profile</h6>
                                <hr />
                                <h6 style={{ cursor: "pointer" }} onClick={() => navigate("/update-password")}>Change Passwords</h6>
                                <hr />
                                <h6 style={{ cursor: "pointer" }} onClick={() => {
                                    sessionStorage.removeItem("loggedUser");
                                    sessionStorage.removeItem("userToken");
                                    window.location.href = "/login"
                                }}>Logout</h6>
                            </div>
                        </div>
                    </div>
            
                    <div class="col-md-4 d-none d-md-block">
                        <div class="box1">
                            <div class="heading">
                                <h3 class="profile-heading">
                                    Orders
                                    <span style={{ display: "inline-block", borderBottom: "3px solid black", width: "12%", textAlign: "left", marginTop: "10px"}}>
                                    </span>
                                </h3>
                            </div>
                            <div class="box1-list">
                                <h6 style={{ cursor: "pointer" }} onClick={() => navigate("/orders")}>Orders</h6>
                                <hr />
                                <h6 style={{ cursor: "pointer" }} onClick={() => navigate("/profile")}>Edit Profile</h6>
                                <hr />
                                <h6 style={{ cursor: "pointer" }} onClick={() => navigate("/update-password")}>Change Passwords</h6>
                                <hr />
                                <h6 style={{ cursor: "pointer" }} onClick={() => {
                                    sessionStorage.removeItem("loggedUser");
                                    sessionStorage.removeItem("userToken");
                                    window.location.href = "/login"
                                }}>Logout</h6>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <h3 class="profile-heading">Edit Profile
                            <span style={{ display: "inline-block", borderBottom: "3px solid black", width: "6%", textAlign: "left", marginTop: "10px"}}>
                            </span>
                        </h3>
                        {/* <div class="align-items-center upload-image">
                            <img src="./images/profile.jpg" alt="Profile Picture" class="rounded-circle img-thumbnail me-3" width="135px" />
                            <button class="btn btn-dark upload-btn">Upload</button>
                        </div> */}
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div class="row">
                                <div class="col-md-12 mb-4">
                                    <input type="text" defaultValue={loggedUser?.firstName} {...register('firstName', { required: 'First name is required' })} class="form-control profile-inputs" placeholder="First Name" />
                                    {errors.firstName && <p className="text-danger px-2">{errors.firstName.message}</p>}
                                </div>
                                <div class="col-md-12 mb-4">
                                    <input type="text" name="lastName" {...register('lastName', { required: 'Last name is required' })} class="form-control profile-inputs" placeholder="Last Name" defaultValue={loggedUser?.lastName} />
                                    {errors.lastName && <p className="text-danger px-2">{errors.lastName.message}</p>}
                                </div>
            
                                <div class="col-md-12 mb-4">
                                    <input type="email" class="form-control profile-inputs" placeholder="Email" value={loggedUser?.email} readonly />
                                </div>
            
                                <div class="col-md-12 mb-4">
                                    <input type="text" defaultValue={loggedUser?.phone} name="phone" {...register('phone', { required: 'Phone number is required' })} class="form-control profile-inputs" placeholder="Phone" />
                                    {errors.phone && <p className="text-danger px-2">{errors.phone.message}</p>}
                                </div>
                                <button class="btn btn-dark upload-btn" type="submit">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </main>
    </>
  );
};
